module.exports = __webpack_public_path__ + "img/ico-dotted3.05765c43.svg";